module.exports = __webpack_public_path__ + "images/emoji/iphone.3ed47588275dc3d4caf3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/iphone.png
// module id = DpvZ
// module chunks = 24